export default {
  intro: {
    default: 'Syötä sopimuksen allekirjoittajan tiedot.',
    gbr: 'Syötä sopimuksen allekirjoittavan osakkaan tiedot.',
    gmbh: 'Syötä sopimuksen allekirjoittavan omistajan tai toimitusjohtajan tiedot.',
  },
  sections: {
    home_address: 'Kotiosoite',
    home_address_help: 'Henkilön asuinosoite, ei ravintolan osoite.',
  },
  form: {
    owner_first_name: {
      label: 'Etunimi',
      placeholder: 'Anna etunimi',
    },
    owner_last_name: {
      label: 'Sukunimi',
      placeholder: 'Anna sukunimi',
    },
    owner_dob: {
      label: 'Syntymäaika',
      placeholder: 'Päivämäärä',
    },
    owner_phone_number: {
      label: 'Puhelin',
    },
    owner_email: {
      label: 'Sähköposti',
      placeholder: 'Anna sähköposti',
      help: 'Tämä voi olla eri kuin kirjautumisesi sähköposti.',
    },
    owner_id_number: {
      label: 'Henkilötunnus (esim. Social security number Yhdysvalloissa)',
      placeholder: '123456789',
    },
  },
  buttons: {
    back: 'Takaisin',
    next: 'Seuraava',
  },
};
